module.exports = __webpack_public_path__ + "img/fr_success_4.f25169a5.png";